module.exports = __webpack_public_path__ + "static/sharing-8c517a7af19542541fb6397da96af3ba.jpg";